import { Heading, SvgIcon, TextLink, Text } from '@cinch-labs/design-system'
import { openLiveChat } from '@cinch-labs/shared-zendesk-messenger'

import styles from './get-in-touch.module.css'

const GetInTouch: React.FC = () => (
  <section className={styles.container}>
    <Heading className={styles.title}>Need to get in touch?</Heading>

    <Text className={styles.body}>
      Our team is online from 8am to 6pm, Monday to Friday.
    </Text>

    <div className={styles.cardGroup}>
      <div className={styles.card}>
        <SvgIcon name="mail" />
        <Heading element="h3" className={styles.cardHeading}>
          Customer Support
        </Heading>

        <TextLink onClick={openLiveChat} hasNoLine>
          Live chat
        </TextLink>

        <TextLink
          href="https://wa.me/447831910589"
          target="_blank"
          rel="noreferrer"
          hasNoLine
        >
          WhatsApp
        </TextLink>

        <TextLink
          href="https://help.cinch.co.uk/hc/en-gb/requests/new?ticket_form_id=25560750129693#"
          target="_blank"
          rel="noreferrer"
          hasNoLine
        >
          Submit a request
        </TextLink>
      </div>

      <div className={styles.card}>
        <SvgIcon name="edit" />
        <Heading element="h3" className={styles.cardHeading}>
          Write to us
        </Heading>
        <Text>
          Cinch Cars Limited
          <br /> Form 2, 18 Bartley Wood
          <br /> Business Park, Bartley Way,
          <br /> Hook, Hampshire RG27 9XA
        </Text>
      </div>
    </div>
  </section>
)

export default GetInTouch
